import React from 'react';
import TransactionReportForm from '../../../features/Financial/TransactionReportForm';
const TrasactionReport = () => {
  return (<TransactionReportForm />
  )
}
export default TrasactionReport;